import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import {
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialog as MatDialog,
} from '@angular/material/legacy-dialog';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { AgGridModule, ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { FeatureFlagUtilService } from 'v2/modules/shared/services/util/feature-flag-util.service';

import { SalesOrderShipmentStatusDialogComponent } from '../sales-order-shipment-status-dialog/sales-order-shipment-status-dialog.component';

import { DialogConfig } from './../../../shared/configs/dialog.config';

@Component({
  selector: 'lum-sales-order-shipment-status-cell-renderer',
  standalone: true,
  imports: [
    CommonModule,
    AgGridModule,
    // COMPONENTS
    SalesOrderShipmentStatusDialogComponent,
    // MATERIAL
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatDialogModule,
  ],
  templateUrl: './sales-order-shipment-status-cell-renderer.component.html',
  styleUrls: ['./sales-order-shipment-status-cell-renderer.component.scss'],
})
export class SalesOrderShipmentStatusCellRendererComponent
  implements ICellRendererAngularComp
{
  constructor(
    private dialog :MatDialog,
    private featureFlagUtilService :FeatureFlagUtilService,
  ) {}

  params :ICellRendererParams;

  agInit(params :any) :void {
    this.params = params;
  }

  refresh(params :any) :boolean {
    return false;
  }

  onToggleShipmentDetails() :void {
    this.dialog.open(SalesOrderShipmentStatusDialogComponent, {
      data: {
        salesOrderShipments: this.params.data.salesOrderShipments.map(
          (shipment) => ({
            id: shipment.id,
            orderId: shipment.orderId,
            orderNumber: shipment.orderNumber,
            orderStatus: shipment.orderStatus,
            warehouseGroup: {
              id:
                shipment.warehouseGroup?.id ?? this.params.data.warehouseGroup?.id,
              label:
                shipment.warehouseGroup?.label ??
                this.params.data.warehouseGroup?.label,
            },
            destinationOms: {
              id:
                shipment.destinationOms?.id ??
                this.params.data.channel?.pushOrderIntegrationMapping
                  ?.appIntegrationAccountId,
              label:
                shipment.destinationOms?.label ??
                this.params.data.channel?.pushOrderIntegrationMapping
                  ?.appIntegrationAccountName,
            },
            sourceReferenceIdentifier: shipment.source_reference_identifier,
          }),
        ),
        ftPushUnPushToFulfilllmentChannel: this.ftPushUnPushToFulfilllmentChannel,
      },
      width: DialogConfig.Size.SMALL,
    });
  }

  get ftPushUnPushToFulfilllmentChannel() :boolean {
    return this.featureFlagUtilService.isFeatureEnabled(
      'red_DV-3334_push_unpush_fulfillment_channel',
    );
  }
}
